
export class SuiteUser {
    constructor(
        public id: number,
        public role: string,
        public suite: string,
        public user: any
    ) {
    }
}



// WEBPACK FOOTER //
// /app/src/app/types/models/SuiteUser.ts